import { Main } from "./component/main";

const appinstance = () => {
  return <Main></Main>;
};

export default appinstance;
